/**
 * Derived from: https://shopify.dev/docs/api/admin-graphql/latest/objects/ReturnReasonDefinition
 * API Version: 2026-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyReturnLineItemKey,
  ShopifyReturnLineItemToReturnReasonDefinitionKey,
  ShopifyReturnReasonDefinitionKey,
  ShopifyReturnReasonDefinitionToReturnLineItemsKey,
  ShopifyReturnReasonDefinitionToShopKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyReturnReasonDefinitionKey,
  "2026-01": {
    name: "Shopify Return Reason Definition",
    graphQLTypename: "ReturnReasonDefinition",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "id",
          },
        },
      },
      {
        name: "Handle",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "handle",
          },
        },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "name",
          },
        },
      },
      {
        name: "Deleted",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "deleted",
          },
        },
      },
      {
        name: "Return Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyReturnReasonDefinitionToReturnLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyReturnLineItemKey,
          inverseFieldKey: ShopifyReturnLineItemToReturnReasonDefinitionKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyReturnReasonDefinitionToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: {
      type: "graphql_list",
      resource: "returnReasonDefinitions",
      filters: {},
    },
  },
};

export const ShopifyReturnReasonDefinition = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
